import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// STEP 2 - Instrumentation: Capture global uncaught errors and promise rejections
window.addEventListener("error", (event) => {
  console.debug("[REACT ERROR / UNCAUGHT ERROR DETECTED]", {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error,
    timestamp: new Date().toISOString()
  });
});

window.addEventListener("unhandledrejection", (event) => {
  console.debug("[UNHANDLED PROMISE REJECTION DETECTED]", {
    reason: event.reason,
    timestamp: new Date().toISOString()
  });
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

